import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import AdminDiscountCodesIndex from "./pages/admin/discount_codes/index";
import AdminSettingsIndex from "./pages/admin/settings/index";
import DashboardIndex from "./pages/dashboard/index";
import DocsIndexPage from "./pages/docs/index";
import HomeIndex from "./pages/home/index";
import LegalPrivacyPage from "./pages/legal/privacy";
import LegalTermsPage from "./pages/legal/terms";
import { initializeSentry } from "./sentry";
import StudioIndex from "./pages/studio/index";

const pages = {
  "admin/discount_codes/index": AdminDiscountCodesIndex,
  "admin/settings/index": AdminSettingsIndex,
  "dashboard/index": DashboardIndex,
  "docs/index": DocsIndexPage,
  "home/index": HomeIndex,
  "legal/privacy": LegalPrivacyPage,
  "legal/terms": LegalTermsPage,
  "studio/index": StudioIndex
};

initializeSentry();

createInertiaApp({
  resolve: (name) => {
    const page = pages[name];

    if (!page) {
      throw new Error(`Unknown Inertia page: ${name}`);
    }

    return page;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
  defaults: {
    prefetch: {
      cacheFor: "1m",
      hoverDelay: 75
    }
  }
});
